/**
 * Initialize scroll-triggered animations
 */
export function initScrollAnimations() {
	const AOS_SELECTOR = "[data-aos]";
	const STARTING_CLASS = "aos-starting-style";
	const OBSERVED_FLAG = "aosObserved";
	const DEFAULT_OFFSET_BOTTOM = "100px";
	const ENABLE_VIEWPORT_CHECK = false;

	const isFullyOutsideViewport = (element) => {
		const rect = element.getBoundingClientRect();
		return (
			rect.bottom <= 0 ||
			rect.top >= window.innerHeight ||
			rect.right <= 0 ||
			rect.left >= window.innerWidth
		);
	};

	const getOffsetBottom = (element) => {
		if (!element.hasAttribute("data-aos-offset")) {
			return DEFAULT_OFFSET_BOTTOM;
		}

		return element.getAttribute("data-aos-offset").trim();
	};

	const applyStartingStyle = (element) => {
		if (!ENABLE_VIEWPORT_CHECK || isFullyOutsideViewport(element)) {
			element.classList.add(STARTING_CLASS);
		} else {
			element.classList.remove(STARTING_CLASS);
		}
	};

	const callback = (entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.remove(STARTING_CLASS);
				entry.target.classList.add("aos-animate");
				observer.unobserve(entry.target);
			}
		});
	};

	if (typeof window.IntersectionObserver !== "function") {
		document.querySelectorAll(AOS_SELECTOR).forEach((element) => {
			element.classList.add("aos-animate");
		});
		return;
	}

	const observeElement = (element) => {
		if (element.dataset[OBSERVED_FLAG] === "true") {
			return;
		}

		applyStartingStyle(element);

		const observer = new IntersectionObserver(callback, {
			rootMargin: `0px 0px -${getOffsetBottom(element)} 0px`,
			threshold: 0,
		});

		observer.observe(element);
		element.dataset[OBSERVED_FLAG] = "true";
	};

	const setupObservers = () => {
		document.querySelectorAll(AOS_SELECTOR).forEach(observeElement);
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", setupObservers, {
			once: true,
		});
	} else {
		setupObservers();
	}
}
